export const CARE_ROLE_OPTIONS = [
  'Healthcare Assistant',
  'Nurse',
];

export const DEFAULT_CARE_ROLE = 'Healthcare Assistant';

export function normalizeCareRoleLabel(role) {
  const text = String(role || '').trim().toLowerCase();
  if (!text) return DEFAULT_CARE_ROLE;
  if (['nurse', 'registered nurse', 'nurse (registered)', 'rn', 'rgn', 'rmn', 'staff nurse', 'senior nurse'].includes(text)) {
    return 'Nurse';
  }
  return DEFAULT_CARE_ROLE;
}

export function resolveKnownCareRoleLabel(role) {
  const text = String(role || '').trim().toLowerCase();
  if (!text) return null;
  if (['nurse', 'registered nurse', 'nurse (registered)', 'rn', 'rgn', 'rmn', 'staff nurse', 'senior nurse'].includes(text)) {
    return 'Nurse';
  }
  if ([
    'healthcare assistant',
    'health care assistant',
    'hca',
    'care assistant',
    'senior care assistant',
    'senior healthcare assistant',
    'support worker',
    'senior support worker',
    'care worker',
    'carer',
  ].includes(text)) {
    return 'Healthcare Assistant';
  }
  return null;
}
